module.exports = __webpack_public_path__ + "img/960.3084b9ec.svg";